export default __webpack_public_path__ + "static/media/123.56f87027.png";